export default "__VITE_ASSET__40d828d5__"